import * as TYPES from './type';
export default {
  //授课讨论
  [TYPES.SK_COMMENT_LIST](state, { result }) {
    state.SKCommentList = result.result
  },
  //讨论详情
  [TYPES.SK_COMMENT_DETAILS](state, { result }) {
    state.SKCommentDetails = result.result
  },
  //讨论添加
  [TYPES.SK_COMMENT_ADD](state, { result }) {
    state.SKCommentAdd = result.result
  },
  //讨论编辑
  [TYPES.SK_COMMENT_EDIT](state, { result }) {
    state.SKCommentEdit = result.result
  },
}
